/**
 * PaymentDateInput — data do pagamento com horário OPCIONAL.
 *
 * O horário começa oculto (00:00) e só aparece quando o usuário clica em
 * "+ horário". O backend guarda timestamptz; o valor é convertido de
 * wall-clock local para UTC em `toIsoInstant`, sem risco de D±1.
 */
interface Props {
    date: string;                          // "YYYY-MM-DD"
    time: string;                          // "HH:MM"
    showTime: boolean;
    onChange: (next: { date: string; time: string; showTime: boolean }) => void;
    disabled?: boolean;
    className?: string;
}

/** Junta data + hora locais no instante ISO (UTC) que o backend espera. */
export const toIsoInstant = (date: string, time: string, showTime: boolean): string | undefined => {
    if (!date) return undefined;
    return new Date(`${date}T${showTime && time ? time : '00:00'}`).toISOString();
};

const PaymentDateInput: React.FC<Props> = ({ date, time, showTime, onChange, disabled, className }) => (
    <div className="flex gap-2 items-center">
        <input type="date" value={date} disabled={disabled} className={className}
            onChange={e => onChange({ date: e.target.value, time, showTime })} />
        {showTime ? (
            <input type="time" value={time} disabled={disabled}
                className="border rounded px-2 py-2 text-sm dark:bg-slate-700 dark:border-slate-600 dark:text-white disabled:bg-gray-100 disabled:cursor-not-allowed"
                onChange={e => onChange({ date, time: e.target.value, showTime })} />
        ) : (
            <button type="button" disabled={disabled}
                onClick={() => onChange({ date, time, showTime: true })}
                className="text-xs text-blue-600 whitespace-nowrap hover:underline disabled:opacity-50">+ horário</button>
        )}
    </div>
);

export default PaymentDateInput;
